export function getFromLocalStorage(key) {
    /* If local storage not supported return null */
    if (!window.localStorage) return null;
    let data = null;
    try {
        data = localStorage.getItem(key);
        /* Check if json string */
        JSON.parse(data);
    } catch(error) {
        captureException(error);
        /* If not json / error occured return the raw data / null */
        return data;
    }
    return JSON.parse(data);
}

export function saveToLocalStorage(key, value) {
    if (!window.localStorage) return false;
    try {
        if (typeof(value)==='object') value = JSON.stringify(value);
        localStorage.setItem(key, value);
    } catch(error) {
        captureException(error);
        return false;
    }
    return true;
}

export function removeFromLocalStorage(key) {
    /* If local storage not supported return null */
    if (!window.localStorage) return false;
    try {
        localStorage.removeItem(key);
    } catch(error) {
        captureException(error);
        return false;
    }
    return true;
}
